import { render, staticRenderFns } from "./reporteCategorias.vue?vue&type=template&id=4f649d50&scoped=true&"
import script from "./reporteCategorias.vue?vue&type=script&lang=js&"
export * from "./reporteCategorias.vue?vue&type=script&lang=js&"
import style0 from "./reporteCategorias.vue?vue&type=style&index=0&id=4f649d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f649d50",
  null
  
)

export default component.exports